/**
 * Page title utility for setting SEO-friendly browser titles
 */

/**
 * Set the page title
 * @param title - The title to set
 * @param includeAppName - Whether to include the app name (default: true)
 */
export function setPageTitle(title: string, includeAppName: boolean = true): void {
  if (typeof window === 'undefined') return;

  const appName = 'Reservation System';
  const fullTitle = includeAppName ? `${title} | ${appName}` : title;

  document.title = fullTitle;
}

/**
 * Reset page title to default
 */
export function resetPageTitle(): void {
  if (typeof window === 'undefined') return;
  document.title = 'Reservation System';
}

/**
 * Common page titles for different sections
 */
export const PAGE_TITLES = {
  // Dashboard
  DASHBOARD: 'ダッシュボード',

  // Conversations
  CONVERSATIONS: '会話一覧',
  CONVERSATION_DETAIL: '会話詳細',

  // Shops
  SHOPS: '店舗一覧',
  CREATE_SHOP: '店舗作成',
  SHOP_DETAIL: '店舗詳細',
  SHOP: '店舗情報',
  NEW_SHOP: '新規店舗追加',

  TOKEN_MANAGEMENT: 'クレジット管理',

  // Reservations
  RESERVATIONS: '予約一覧',
  RESERVATION_DETAIL: '予約詳細',
  NEW_RESERVATION: '新規予約',

  // Seating
  SEATING: '座席管理',
  SEATING_DETAIL: '座席詳細',

  // Calendar
  CALENDAR_SYNC: 'カレンダー同期',

  // Account
  ACCOUNT: 'アカウント設定',
  PROFILE: 'プロフィール',

  // Auth
  LOGIN: 'ログイン',
  REGISTER: '新規登録',
  FORGOT_PASSWORD: 'パスワードをお忘れの方',
  RESET_PASSWORD: 'パスワード再設定',

  // Error pages
  NOT_FOUND: 'ページが見つかりません',
  ERROR: 'エラー',
} as const;

/**
 * Generate dynamic page titles with context
 */
export function generatePageTitle(
  baseTitle: string,
  context?: Record<string, string | number>
): string {
  if (!context) return baseTitle;

  const contextParts = Object.entries(context)
    .map(([key, value]) => `${key}: ${value}`)
    .join(' - ');

  return `${baseTitle} - ${contextParts}`;
}
